<template>
    <div style="background-color: #fff;border-radius: 4px;border: 1px solid #D9E4F8;padding:24px;">
        <!-- 先判断 traceData 是否有有效数据，无数据时显示空提示 -->
        <div v-if="traceData && traceData.length > 0">
            <div style="display: flex;align-items:start;">
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <img :src="imgIcStart" alt="" style="width: 24px;height: 24px;">
                    <div style="width: 1px;background: #D9E4F8;height: 140px;"></div>
                </div>
                <div style="margin-left: 16px;">
                    <div style="font-size: 12px;color: #0E193B;opacity: 0.5;margin-bottom: 4px;">{{ $t('driver.起始时间') }}：
                    </div>
                    <!-- 访问属性前先判断元素是否存在 -->
                    <div style="font-size: 12px;color: #0E193B;">{{ traceData[0]?.GpsDateTime || '-' }}</div>
                    <div style="font-size: 12px;color: #0E193B;opacity: 0.5;margin-top: 8px; margin-bottom: 4px;">
                        {{ $t('driver.起始位置') }}：</div>
                    <div style="font-size: 12px;color: #0E193B;">{{ traceData[0]?.Position || '未知位置' }}</div>
                </div>
            </div>
            <div style="display: flex;align-items:start;">
                <div style="display: flex;flex-direction: column;align-items: center;">
                    <div style="width: 1px;background: #D9E4F8;height: 60px;"></div>
                    <img :src="imgIcEnd" alt="" style="width: 24px;height: 24px;">
                </div>
                <div style="margin-left: 16px;">
                    <div style="font-size: 12px;color: #0E193B;opacity: 0.5;margin-bottom: 4px;">{{ $t('driver.终止时间') }}：
                    </div>
                    <!-- 访问属性前先判断元素是否存在 -->
                    <div style="font-size: 12px;color: #0E193B;">{{ traceData[traceData.length - 1]?.GpsDateTime || '-' }}
                    </div>
                    <div style="font-size: 12px;color: #0E193B;opacity: 0.5;margin-top: 8px; margin-bottom: 4px;">
                        {{ $t('driver.终止位置') }}：</div>
                    <div style="font-size: 12px;color: #0E193B;">{{ traceData[traceData.length - 1]?.Position || '未知位置' }}
                    </div>
                </div>
            </div>
        </div>
        <!-- 空数据兜底显示 -->
        <div v-else style="text-align: center; padding: 40px 0; color: #999; font-size: 12px;">
            {{ $t('public.noData') }} <!-- 或自定义空提示文本，如"暂无轨迹数据" -->
        </div>
    </div>
</template>
<script>
import imgIcStart from "@/assets/images/ic_start.png";
import imgIcEnd from "@/assets/images/ic_end.png";
export default {
    props: {
        traceData: {
            type: Array,
            default: () =>
                [] // 确保 props 默认值为空数组，避免 undefined
        }
    }
}
</script>